import { rcUrl } from "src/businessServices/services/bsChat/apiChat";
import { getFileAccessToken } from "src/appStore";

export const createFileAccessUrl = (url: string) =>
  `${rcUrl(url)}?token=${encodeURIComponent(getFileAccessToken())}`;
